import { useDispatch } from "react-redux";
import { TFunction } from "i18next";
import { hideAlert, showAlert } from "../../../features/slices/applicationSlice";

const useAlerts = ({ translate }: { translate: ((key: string) => string) | TFunction }) => {
    const dispatch = useDispatch();

    const showCancelCarcinogenicReportAlert = ({ confirmAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.showCancelCarcinogenicReportAlert.title'),
                message: translate('alerts.showCancelCarcinogenicReportAlert.message'),
                icon: 'info',
                confirmText: translate('alerts.showCancelCarcinogenicReportAlert.confirmText'),
                confirmAction: confirmAction
            })
        );
    };

    const showSendCarcinogenicReportAlert = ({ confirmAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.sendPresentation.title'),
                // El aviso a backoffice sale solo al enviar (`EditarInformeApp`),
                // por eso ya no existe "Notificar corrección": se le dice acá.
                message: `${translate('alerts.sendPresentation.message')}\n\n${translate(
                    'alerts.sendPresentation.notificacionBackoffice'
                )}`,
                icon: 'info',
                confirmText: translate('alerts.sendPresentation.confirmText'),
                cancelText: translate('alerts.sendPresentation.cancelText'),
                confirmAction: confirmAction
            })
        );
    };

    /**
     * Con `faltantes` el diálogo dice qué completar (paso, responsable y dato)
     * en lugar del genérico "revisá las tabs". Sin ellos —el back rechazó el
     * envío— queda el texto genérico.
     */
    const showSendCarcinogenicReportFailAlert = (faltantes: string[] = []) => {
        dispatch(
            showAlert({
                title: translate('alerts.sendPresentationsFail.title'),
                message: faltantes.length
                    ? `${translate('alerts.sendPresentationsFail.messageDetalle')}\n\n${faltantes
                          .map((faltante) => `• ${faltante}`)
                          .join('\n')}`
                    : translate('alerts.sendPresentationsFail.message'),
                messageAlign: faltantes.length ? 'left' : undefined,
                icon: 'error',
                confirmText: translate('alerts.sendPresentationsFail.confirmText'),
                confirmAction: () => dispatch(hideAlert())
            })
        );
    };


    const showSendBlockedByCorrectionsAlert = (cantidad: number) => {
        dispatch(
            showAlert({
                title: translate('alerts.sendBlockedByCorrections.title'),
                message:
                    cantidad === 1
                        ? translate('alerts.sendBlockedByCorrections.messageOne')
                        : String(translate('alerts.sendBlockedByCorrections.messageOther')).replace(
                              '{{count}}',
                              String(cantidad)
                          ),
                icon: 'warning',
                confirmText: translate('alerts.sendBlockedByCorrections.confirmText'),
                confirmAction: () => dispatch(hideAlert())
            })
        );
    };

    return {
        showCancelCarcinogenicReportAlert,
        showSendCarcinogenicReportAlert,
        showSendCarcinogenicReportFailAlert,
        showSendBlockedByCorrectionsAlert
    };
};

export default useAlerts;